import { Link } from 'react-router';
import { ArrowIcon } from '@/components/ui/Button';
import type { ProductCard } from '@/types/api';

/** Text-led editorial product list — used where product photography is not (yet) available. */
export function ProductIndex({ products }: { products: ProductCard[] }) {
  return (
    <ul className="border-t border-line-strong/70">
      {products.map((p) => {
        const spec = p.specifications[0];
        return (
          <li key={p.id} className="group relative grid gap-x-8 gap-y-2 border-b border-line-strong/70 py-6 sm:grid-cols-12 sm:items-center">
            <div className="sm:col-span-5">
              <p className="text-[12px] font-semibold tracking-[0.14em] text-accent-dark uppercase">{p.category.name}</p>
              <h4 className="mt-1 font-display text-[20px] font-bold tracking-tight text-primary">
                <Link to={`/products/${p.slug}`} className="after:absolute after:inset-0 focus-visible:outline-none">
                  {p.name}
                </Link>
              </h4>
            </div>
            <p className="text-[14.5px] text-muted sm:col-span-4">
              {spec ? (
                <>
                  {spec.label}: <span className="text-ink-soft">{spec.value}</span>
                </>
              ) : (
                p.summary
              )}
            </p>
            <div className="flex items-center justify-between gap-4 sm:col-span-3 sm:justify-end">
              {p.moq && <span className="text-[14px] font-semibold text-primary">MOQ {p.moq}</span>}
              <span className="grid h-10 w-10 place-items-center rounded-full border border-line-strong text-primary transition-colors group-hover:border-primary group-hover:bg-primary group-hover:text-white">
                <ArrowIcon />
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
